import { useSelector } from "react-redux";
import { RootState } from "../store";

/**
 * Get current languages selection
 * @returns 
 */
export const useDefaultLanguage= ():string => {
  return useSelector((state: RootState) => state.config.defaultLanguage);
}